import styled from 'styled-components';
import { mq } from '../../../theme/mediaQueries';

export const StyledHeader = styled.header`
  height: var(--topbar-h);
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 var(--s-6);
  gap: var(--s-4);
  background: var(--surface);
  border-bottom: 1px solid var(--line);
  position: sticky;
  top: 0;
  z-index: var(--z-sticky);
  flex-shrink: 0;

  ${mq.ltMd} {
    padding: 0 16px;
    gap: 12px;
  }
`;

export const StyledHeaderSpacer = styled.div`
  flex: 1;
`;

export const StyledBreadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex-shrink: 1;

  .ws-name {
    font-size: var(--t-md);
    color: var(--muted);
    font-weight: 500;
    white-space: nowrap;
  }

  .chev {
    color: var(--muted-2);
    display: flex;
    align-items: center;
    flex-shrink: 0;
    svg { width: 14px; height: 14px; }
  }

  [dir="rtl"] & .chev svg { transform: scaleX(-1); }

  .page-title {
    font-size: var(--t-md);
    font-weight: 600;
    color: var(--ink);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${mq.ltMd} {
    .ws-name, .chev { display: none; }
  }
`;

export const StyledHeaderAction = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
`;

export const StyledHeaderActionColumn = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
`;

export const StyledHeaderMobileToggle = styled.button`
  display: none;

  ${mq.ltMd} {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border: none;
    background: transparent;
    color: var(--ink);
    cursor: pointer;
    border-radius: var(--r-sm);
    padding: 0;
    transition: background var(--dur-base) var(--ease-out);

    &:hover { background: rgba(9, 15, 56, 0.06); }

    svg { width: 20px; height: 20px; }
  }
`;

export const StyledCmdKHint = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: var(--s-2) var(--s-2) var(--s-2) var(--s-3);
  height: 34px;
  min-width: 260px;
  border-radius: var(--r-md);
  border: 1px solid var(--line);
  background: var(--paper);
  color: var(--muted);
  font: inherit;
  font-size: var(--t-sm);
  cursor: pointer;
  white-space: nowrap;
  transition: background var(--dur-base) var(--ease-out),
    border-color var(--dur-base) var(--ease-out);

  &:hover {
    background: var(--surface);
    border-color: var(--muted-3);
  }

  .search-icon {
    display: flex;
    flex-shrink: 0;
    color: var(--muted);
    svg { width: 15px; height: 15px; }
  }

  .placeholder {
    flex: 1;
    text-align: start;
    color: var(--muted);
    font-size: var(--t-sm);
  }

  kbd {
    font: inherit;
    font-weight: 600;
    font-size: 11px;
    background: rgba(9,15,56,0.04);
    border: 1px solid rgba(9,15,56,0.1);
    border-bottom-width: 2px;
    border-radius: 4px;
    padding: var(--s-1) var(--s-1);
    line-height: 1;
    color: var(--muted);
    flex-shrink: 0;
  }

  ${mq.ltMd} {
    min-width: unset;
    width: 34px;
    height: 34px;
    padding: 0;
    justify-content: center;
    .placeholder { display: none; }
    kbd { display: none; }
  }
`;

export const StyledNotificationBell = styled.button`
  position: relative;
  width: 34px;
  height: 34px;
  border-radius: var(--r-md);
  border: 1px solid var(--line);
  background: var(--surface);
  color: var(--muted);
  display: grid;
  place-items: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background var(--dur-base) var(--ease-out),
    border-color var(--dur-base) var(--ease-out);

  svg { width: 17px; height: 17px; }

  &:hover {
    background: var(--paper);
    border-color: var(--muted-3);
  }

  .dot {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--danger);
    border: 2px solid var(--surface);
  }
`;

export const StyledHeaderTitle = styled.h1`
  color: var(--ink);
  font-weight: 700;
  font-size: var(--t-2xl);
  letter-spacing: var(--tracking-tight);
  line-height: var(--lh-snug);
  flex: 1;
  margin: 0;

  ${mq.ltMd} {
    font-size: var(--t-xl);
  }
`;
